import getCharts from '../getCharts'
import {GetProviderOfKareo}  from '../../constants/api.config'

export default async function SaveKareo(mode) {
  try {
    const payload = { Mode:mode }
    const res = await getCharts(GetProviderOfKareo, payload)
    return res.data
  } catch (error) {
    return error
  }
}
